/**
 *  Shoepage slider - uses Slick.js for the slider/slider nav
 */
class Shoe {

    constructor(data) {
        this.title = data.title;
        this.placeholder = data.placeholder;
        this.year = data.year;
        this.desc = data.desc;
        this.purchase_url = data.purchase_url;
        this.images = data.images;
        this.image = null;
    }
}

export default class ShoeBox {

    constructor() {
        /*
            How are we getting the shoe data?
            Is it being rendered server side?
            How are we filtering them?
            Is there going to be filters?
         */
        this.shoesContainer = $('.shoe-list');
        this.shoes = [];
        this.fetchShoes();
    }

    /*
        If we're not going to get data via ajax
        and render them server side skip:
            fetchShoes()
                new Shoe(d)
            buildShoeList(shoes)
        and go to:
            shoe.click((e) => this.shoeClick(e));
     */
    /**
     * Populate .shoe-list with shoes from the shoes param.
     * Pass in an array of shoes for filtering purposes in the future.
     * @param shoes | Array of Shoe objects
     */
    buildShoeList(shoes) {
        shoes.forEach((_shoe, index) => {
            let shoe = $('<div class="shoe"></div>'),
                overlay = $('<div class="shoe-overlay"></div>'),
                title = $('<p class="shoe-title"></p>');

            if(_shoe.placeholder)
            {
                shoe.addClass('placeholder');
            }
            else
            {
                title.text(_shoe.title);
                overlay.append(title);

                shoe.click((e) => this.shoeClick(e));
            }

            shoe.append(overlay).css({
                'background-image': 'url('+_shoe.images[0]+')'
            }).attr('data-index', index);

            this.shoesContainer.append(shoe);
        });
        this.shoesContainer.children('.shoe:first-of-type').click();
    }

    buildSliders(shoe) {
        let shoebox = $(document).find('.slides-container'),
            navSlider = $(document).find('.slider-navigation');

        if ( shoebox.length > 0 ) {
            shoebox.slick('unslick');
            shoebox.remove();
            navSlider.remove();
        }
        shoebox = $('<div class="slides-container"></div>');
        navSlider = $('<div class="slider-navigation"></div>');

        shoe.images.forEach((image) => {
            let mainSlide = this.buildMainSlide(shoe, image),
                navSlide = this.buildNavSlide(shoe, image);
            shoebox.append(mainSlide);
            navSlider.append(navSlide);
            navSlider.find('.thumbnail').first().addClass('active');
        });

        let link = $('<div class="button-wrapper"><a class="button medium"></a></div>');
        link.find('.button').text('Purchase').attr('href', shoe.purchase_url).attr('target', '_blank');

        let shoeBoxSlider = $(document).find('.shoebox-slider');
        shoeBoxSlider.append([shoebox, navSlider]);
        let buttonWrapper = shoeBoxSlider.find('.button-wrapper');
        buttonWrapper.remove();
        shoeBoxSlider.append(link);

        shoebox.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
        });
        // Set active slider nav thumbnail
        $(document).on('afterChange', '.slides-container', (slick, currentSlide) => {
            $(document).find('.shoes .thumbnail').removeClass('active');
            $(document).find('.shoes .thumbnail').eq(currentSlide.currentSlide).addClass('active');
        });

        /*
            Using Slick as a nav for the main slider wasn't working as intended.
            Since shoebox/navSlider is being dynamically populated and added to DOM
            I don't think Slick is able to control from one dynamic DOM el to another.
            However, jQuery's delegated events can using .index() and Slick's slickGoTo
            function.
         */
        navSlider.on('click', '.thumbnail', function() {
            let index = $(this).index();
            $(".shoes .thumbnail").removeClass('active');
            $(this).addClass('active');
            shoebox.slick('slickGoTo', index, false);
        });


    }

    /**
     * Returns a slide DOM element for the main slider
     * @param shoe | Object
     * @param image | String
     */
    buildMainSlide(shoe, image) {
        let slide = $('<div class="slide"></div>'),
            info = $('<div class="slide-info"></div>'),
            year = $('<span class="year"></span>'),
            title = $('<h1></h1>'),
            desc = $('<p></p>'),
            link = $('<a class="button medium"></a>');

        year.text(shoe.year);
        title.text(shoe.title);
        desc.text(shoe.desc);
        link.text('Purchase').attr('href', shoe.purchase_url).attr('target', '_blank');

        info.append([year, title, desc, link]);
        let shoeImage = $("<div></div>").addClass('shoe-image');
        shoeImage.html('<img src="'+image+'" />');
        slide.append([shoeImage]);

        // Append info above slider - prevents text from sliding with shoe
        $('.shoebox').find('.slide-info').remove();
        $('.shoebox').append(info);

        return slide;
    }

    /**
     * Returns a slide DOM element for the slider navigation
     * @param shoe | Object
     * @param image | String
     */
    buildNavSlide(shoe, image) {
        let slide = $('<div class="thumbnail"></div>');
        slide.css({'background-image': 'url('+image+')'});
        return slide;
    }

    buildShoeThumbnails(shoe) {
        let sliderNav = $(document).find('.slider-navigation');
        if ( sliderNav.length > 0 ) {
            sliderNav.slick('unslick');
            sliderNav.remove();
        }
        sliderNav = $('<div class="slider-navigation"></div>');
        shoe.images.forEach((image) => {
            sliderNav.append('<div class="thumbnail" style="background-image: url('+image+');"></div>');
        });
        $(document).find('.shoebox-slider').append(sliderNav);
        sliderNav.slick({
            slidesToShow: shoe.images.length,
            asNavFor: '.shoebox-slider',
            dots: false
        });
    }

    shoeClick(event) {
        let target = $(event.currentTarget),
            index = target.data('index'),
            shoe = this.shoes[index];

        $('.shoe-list .shoe').removeClass('active');
        target.addClass('active');
        this.buildSliders(shoe);
    }

    /**
     * Return an array of filtered shoes based on type.
     * @param type | String
     * @returns Array
     */
    sortShoes(type) {
        return this.shoes.filter((shoe) => {
            return shoe.type === type;
        });
    }

    fetchShoes() {
        /*
            This is where we would fetch the shoes if we needed to.
            Call this.buildShoeList(shoes) when results are fetched successfully.
            demo_shoes is seed data to test with.
         */
        let demo_shoes = [
            {
                title: 'Air Jordan Super.Fly 2017',
                year: 2017,
                desc: "The Super.Fly 3 features the latest revolution in basketball cushioning: ultra-responsive Nike React foam designed to help you play harder and go farther.",
                purchase_url: 'https://store.nike.com/us/en_us/pw/jordan-blake-griffin/9seZofq.',
                images: [
                    '/img/shoes/6C8A3105.png',
                    '/img/shoes/6C8A3115.png',
                    '/img/shoes/6C8A3118.png',
                    '/img/shoes/6C8A3120.png',
                    '/img/shoes/6C8A3137.png',
                ]
            },
            {
                title: 'Coming Soon',
                placeholder: true,
                year: 0,
                desc: '',
                purchase_url: '',
                images: [
                    '/img/shoes/jordan-logo.svg'
                ]
            }
        ];
        demo_shoes.forEach((shoe) => {
            this.shoes.push(new Shoe(shoe));
        });
        this.buildShoeList(this.shoes);
    }

    /**
     * Update the main ShoeBox area to the selected shoe.
     * @param shoe | Object
     */
    selectShoe(shoe) {

    }

}


// WEBPACK FOOTER //
// ./public/js/ShoeBox.js